import styles from './SingleSlider.module.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperClass } from 'swiper/react';
import cn from 'classnames';
import { useRef, ReactNode } from 'react';
import { Pagination } from 'swiper/modules';
import { useAdaptiveLayout } from '@/hooks/useAdaptiveLayout';

type SingleSliderProps = {
  className?: string;
  children: ReactNode;
  slidesPerView?: number;
  gap?: number;
};

export function SingleSlider({
  className,
  children,
  slidesPerView = 1,
  gap = 16,
}: SingleSliderProps) {
  const swiperRef = useRef<SwiperClass | null>(null);
  const sliderClassName = cn(styles.slider, className);
  const { isTablet } = useAdaptiveLayout();

  return (
    <Swiper
      className={sliderClassName}
      onSwiper={(swiper) => (swiperRef.current = swiper)}
      speed={isTablet ? 400 : 1000}
      slidesPerView={slidesPerView}
      pagination={{
        bulletClass: styles.bullet,
        bulletActiveClass: styles.bulletActive,
      }}
      modules={[Pagination]}
      effect="slide"
      spaceBetween={gap}
    >
      {children}
    </Swiper>
  );
}
